import axios from 'axios';
import config from '../config';

const { api } = config;

const cnaeAxios = axios.create({
  baseURL: `${api.API_URL}/api/cnae`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
cnaeAxios.interceptors.request.use(
  (config) => {
    const authUser = sessionStorage.getItem('authUser');
    if (authUser) {
      const user = JSON.parse(authUser);
      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
cnaeAxios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.message || error.message || 'Erro ao buscar CNAE';
    return Promise.reject(new Error(message));
  }
);

export interface CnaeDto {
  code: string;
  description: string;
}

/**
 * CNAE Service
 */
export const cnaeService = {
  /**
   * Search CNAE codes by term
   */
  search: async (term: string): Promise<CnaeDto[]> => {
    return cnaeAxios.get('/search', { params: { term } });
  },

  /**
   * Get CNAE by code
   */
  getByCode: async (code: string): Promise<CnaeDto> => {
    return cnaeAxios.get(`/${code}`);
  },
};

export default cnaeService;
